<div #openseadragonContainer class="viewer {{ cursorClass }}"></div>
